<template>
    <Loader v-if="loading" />
    <div v-else>


        <div id="newPropModal" v-if="newId" class="creating-modal-container">
            <div class="modal-wrapper">
                <div class="modal-mask" v-on:click="closeNewId"></div>
                <div class="modal-container with-boxes" slot="modal-container">

                    <div class="close" v-on:click="closeNewId">
                            <svg xmlns="http://www.w3.org/2000/svg" width="11.891" height="11.891" viewBox="0 0 23.781 23.781">
                              <path class="fill-grey" d="M382.829,147l8.485,8.485a2,2,0,0,1-2.829,2.829L380,149.829l-8.485,8.485a2,2,0,0,1-2.829-2.829L377.172,147l-8.486-8.485a2,2,0,0,1,2.829-2.829L380,144.172l8.485-8.486a2,2,0,0,1,2.829,2.829Z" transform="translate(-368.125 -135.125)"/>
                            </svg>
                    </div>
                    <h1>{{ $t('properties.created.headline') }}</h1>
                    <p>
                        {{ $t('properties.created.description') }}
                    </p>
                    <div class="content-box">
                        <div class="boxes">
                            <a disabled href="#" class="col">
                                <div class="content">
                                    <div class="icon">
                                        <img src="/images/img/dashboard/screening.png">
                                    </div>
                                    <h3>{{  $t('dashboard.col.two.text') }}</h3>
                                </div>
                            </a>
                            <a disabled href="#" class="col">
                                <div class="content">
                                    <div class="icon">
                                        <img src="/images/img/dashboard/digital-contract.png">
                                    </div>
                                    <h3>{{  $t('dashboard.col.three.text') }}</h3>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div>
                        <router-link disabled to="#" class="button transparent">{{ $t('properties.created.create-another-property') }}</router-link>
                    </div>
                </div>
           </div>
       </div>

        <div class="inner properties no-content" v-if="!numberOfProperties">
            <div class="headline">
                <h1>{{$t('properties.overview.headline')}}</h1>
            </div>
            <div class="no-content-box">
                <div>
                    <h2>{{$t('properties.none.headline')}}</h2>
                    <p>{{$t('properties.none.text')}}</p>
                    <router-link disabled to="#" class="button green">
                        <SvgIcon icon="plus-circle" />
                        {{$t('properties.add.button')}}
                    </router-link>
                </div>
            </div>
        </div>

        <!-- PROPERTIES OVERVIEW -->
        <div class="inner properties with-content with-tables" v-else>
            <div class="headline">
                <h1>{{$t('properties.overview.headline')}}</h1>
            </div>
            <tabs>
                <tab :name="$t('properties.tabs.all')">
                    <PropertyList :data="properties" v-on:refresh="load" />
                </tab>
                <tab :name="$t('properties.tabs.for-rent')">
                    <PropertyList :data="forRent" v-on:refresh="load" />
                </tab>
                <tab :name="$t('properties.tabs.leased')">
                    <PropertyList :data="leased" v-on:refresh="load" />
                </tab>
            </tabs>
            <span style="display: none;" id="deleteConfirmation">{{$t('properties.delete.confirmation')}}</span>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapGetters} from 'vuex';


    import SvgIcon from '../../components/Svg.vue';
    import PropertyList from '../../components/PropertyList.vue';
    import Loader from '../../components/Loader.vue';
    import createEntity from "../../mixins/create-entity";
    export default {
        mixins: [createEntity],
        components:{
            SvgIcon,
            PropertyList,
            Loader,
        },
        data: () => ({
            loading: false,
            list: [],
        }),
        computed: {
            ...mapGetters([
                'getProperties',
                'getToken'
            ]),
            properties() {
                return this.list.map(item => {
                    item.text_status = item.signed ? this.$t('properties.status.leased') : this.$t('properties.status.forrent');
                    item.zipcode_city = item['zip_code'] + ' ' + item['city'];
                    return item;
                });
            },
            forRent() {
                return this.properties.filter(row => !Number(row.signed));
            },
            leased() {
                return this.properties.filter(row => Number(row.signed));
            },
            newId() {
                return this.$route.query.newid;
            },
            numberOfProperties() {
                return this.properties.length;
            },
        },
        methods: {
            load() {
                Vue.api.get('/property/list', {}, {
                    before: () => this.loading = true,
                    always: () => this.loading = false,
                    callback: data => this.list = data,
                });
            },
            filterTable(ref, value) {
                this.$refs[ref].setFilter(this.filterText);
            },
            setTableSorting(ref, algo) {
                switch (String(algo)) {
                    case '':
                        this.$refs[ref].setOrder('oldFirst', false);
                        break;
                    case '10':
                        this.$refs[ref].setOrder('oldFirst', true);
                        break;
                    case '20':
                        this.$refs[ref].setOrder('address', true);
                        break;
                    case '30':
                        this.$refs[ref].setOrder('zipcode', true);
                        break;
                }
            },
            /**
             * status=false will select all properties regardless of status
             */
            filterProperties(status)
            {
                let properties = this.getProperties;
                let list = this.setTextStatus(properties);
                let result = [];
                for (var i in properties) {
                    if (status === false || Number(properties[i].signed) == Number(status)) {
                        result.push(properties[i]);
                    }
                }
                return result;
            },
            deleteProperty(id)
            {
                if (confirm(document.getElementById('deleteConfirmation').innerHTML)) {
                    if (typeof id == 'undefined') {
                        id = this.showEdit;
                    }
                    var self = this;
                    axios({
                        method: 'DELETE',
                        url: window.config.apiUrl + 'api/property/' + id,
                        cancelToken: window.AuthorizationCancelSource.token,
                    }).then(response => {
                        this.showEdit = false;
                        this.$store.dispatch('fetchProperties');
                        this.$store.commit('setSuccessBarMessage', this.$t('properties.deleted.label'));
                    });
                }
            },
            editProperty(id) {
                var properties = this.getProperties;
                for (var i in properties) {
                    if (properties[i].id == id) {
                        this.editZipcode = properties[i].zip_code;
                        this.editCity = properties[i].city;
                        this.editAddress = properties[i].address;
                        this.editClient = properties[i].client_id;
                    }
                }
                this.showEdit = id;
            },
            saveProperty() {
                axios({
                    method: 'PATCH',
                    url: window.config.apiUrl + 'api/property/' + this.showEdit,
                    cancelToken: window.AuthorizationCancelSource.token,
                    data: {
                        zipcode: this.editZipcode,
                        address: this.editAddress,
                        city: this.editCity,
                        client_id: this.editClient
                    }
                }).then(response => {
                    this.showEdit = false;
                    this.$store.dispatch('fetchProperties');
                    this.$store.commit('setSuccessBarMessage', this.$t('properties.saved.label'));
                });
            },
            setTextStatus(properties){
                var self = this;
                if (properties == undefined || !properties || typeof properties.forEach != 'function') {
                    return;
                }
                properties.forEach(function (item) {
                    item['text_status'] = item.signed ? self.$t('properties.status.leased') : self.$t('properties.status.forrent');
                    item['zipcode_city'] = item['zip_code'] + ' ' + item['city'];
                    item['display_dropdown'] = true;
                });
            },
            loadClients() {
                axios({
                    method: 'GET',
                    url: window.config.apiUrl + 'api/client',
                    cancelToken: window.AuthorizationCancelSource.token,
                }).then(response => {
                    this.clients = response.data;
                });
            },
            closeNewId: function (event) {
                $('#newPropModal').fadeOut();
            },
            close() {
                this.showEdit = false;
            }
        },
        created() {
            this.load();
        },
        mounted(){
            var inputs = document.getElementsByClassName('form-control');
            setTimeout(function() {
                for (var i in inputs) {
                    inputs.item(i).value = '';
                }
            }, 1000);
            this.$store.dispatch('fetchProperties');
            this.loadClients();
        },
    }
</script>
<style>
</style>
